import { Stack } from '@fluentui/react';
import { NoDataView } from 'common/components/DataPlaceholders';
import { DocumentList } from 'common/components/DocumentList';
import { getWindowDimensions } from 'common/utils/columnUtilities';
import React from 'react';
import { PurchaseOrderDetails_purchaseOrder_entityDocumentsByEntityId } from '../../../__generated__/PurchaseOrderDetails';
import { columns } from './column.data';

interface FilesProps {
  fileListData: PurchaseOrderDetails_purchaseOrder_entityDocumentsByEntityId;
}
export const Files: React.FC<FilesProps> = ({ fileListData }) => {
  const { width } = getWindowDimensions();
  const documentViewPosition = width ? width * 0.8 - 500 : 50;

  return (
    <Stack tokens={{ childrenGap: 10, padding: '24px 0px 0px 0px' }}>
      <Stack tokens={{ childrenGap: 10, padding: 10 }}>
        {fileListData.nodes.length && (
          <DocumentList
            isNew={false}
            columns={columns}
            data={fileListData.nodes || []}
            paddingLeft={documentViewPosition}
          />
        )}
        <NoDataView
          show={fileListData.nodes.length === 0}
          title="No Attachments"
        />
      </Stack>
    </Stack>
  );
};
